<script lang="ts">
	import type { ChainData } from '#lib/models/index.js'
	import { m } from '#lib/paraglide/messages.js'

	let {
		leftChain,
		rightChain,
		leftValue,
		rightValue,
		ratio,
		prettyRatio,
		prettyLeftValue,
		prettyRightValue,
		metric,
	}: {
		leftChain: ChainData
		rightChain: ChainData
		leftValue?: Nullable<number>
		rightValue?: Nullable<number>
		ratio: Nullable<number>
		prettyRatio: string
		prettyLeftValue: string
		prettyRightValue: string
		metric: string
	} = $props()
</script>

{#if leftValue != null && rightValue != null && ratio != null}
	{#if !Number.isFinite(ratio)}
		{m.chain_page_compare_values({
			leftChain: leftChain.name,
			leftValue: prettyLeftValue,
			rightChain: rightChain.name,
			rightValue: prettyRightValue,
			metric,
		})}
	{:else if ratio > 1}
		{m.chain_page_compare_left_better({
			leftChain: leftChain.name,
			prettyRatio,
			rightChain: rightChain.name,
			metric,
		})}
	{:else if ratio < 1}
		{m.chain_page_compare_right_better({
			leftChain: leftChain.name,
			prettyRatio,
			rightChain: rightChain.name,
			metric,
		})}
	{:else}
		{m.chain_page_compare_same({
			leftChain: leftChain.name,
			rightChain: rightChain.name,
			metric,
		})}
	{/if}
{:else if leftValue == null && rightValue == null}
	{m.chain_page_compare_no_both({
		leftChain: leftChain.name,
		rightChain: rightChain.name,
	})}
{:else if leftValue != null && rightValue == null}
	{m.chain_page_compare_no_right({
		leftChain: leftChain.name,
		rightChain: rightChain.name,
		metric,
		leftValue: prettyLeftValue,
	})}
{:else if leftValue == null && rightValue != null}
	{m.chain_page_compare_no_left({
		leftChain: leftChain.name,
		rightChain: rightChain.name,
		metric,
		rightValue: prettyRightValue,
	})}
{/if}
